import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { PermissionObject } from '@eadsysteme/ewsauthclient-v1';
import { SessionService } from '../../../services/session.service';
import PermissionTypeEnum = PermissionObject.PermissionTypeEnum;

/** Ist der eingeloggte Benutzer die Hausverwaltung? dev/support zählen mit, im Zweifel nein. */
@Injectable({ providedIn: 'root' })
export class PropertyManagementRightsService {
	private readonly sessionService = inject(SessionService);

	resolve(): Observable<boolean> {
		if (this.sessionService.isPropertyManagement() || this.sessionService.isDevRole() || this.sessionService.isSupportRole()) {
			return of(true);
		}
		return this.sessionService.getAllPermissionsOfLoggedInUser().pipe(
			map((permissions) => (permissions ?? []).some((permission) => permission.permissionType === PermissionTypeEnum.PROPERTY_MANAGEMENT)),
			catchError(() => of(false))
		);
	}
}
